package com.patronat.top.features.dashboard.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.DashboardStatsResponse
import com.patronat.top.features.dashboard.domain.repository.DashboardRepository
import com.patronat.top.features.dashboard.domain.usecase.command.GetDashboardStatsCommand

class GetDashboardStatsUseCase(
    private val dashboardRepository: DashboardRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetDashboardStatsCommand, DomainResult<DashboardStatsResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetDashboardStatsCommand): DomainResult<DashboardStatsResponse> {
        return dashboardRepository.getDashboardStats()
    }
}
